import { type ApiSdkVersion } from '@lune/common/api'

export let version: ApiSdkVersion = {
  apiVersion: process.env.API_VERSION as string
}

console.log(`API SDK version: ${version.apiVersion}`)

export const forceApiVersionForTesting = (newVersion: ApiSdkVersion): void => {
  console.log('Setting API version for testing:', newVersion)
  version = newVersion
}
